import styles from "./ContractStyles";

const jsonView = {
  type: "page",
  items: [
    {
      type: "view",
      styles: {
        margin: 5,
        padding: 5,
      },
      items: [
        {
          type: "text",
          styles: {
            ...styles.textContent,
            fontSize: 13,
            marginTop: 15,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
            paddingLeft: 20,
            paddingRight: 20,
          },
          content:
            "ADDENDUM TO THE TRANSPORT AND SERVICES AGREEMENT FOR YACHTS",
        },

        {
          type: "text",
          styles: {
            fontFamily: "Helvetica-Oblique",
            textAlign: "center",
            marginBottom: 20,
            paddingLeft: 20,
            paddingRight: 20,
            fontSize: 8,
          },
          content:
            "This document modifies the Transport and Services Agreement. If there is no change to the price, date/place of disembarkation, appendix I - Rider of the Agreement should be used instead.",
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: 20,
          },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 8,
              },
              content: "Further to the Transport Agreement n° ",
            },
            {
              type: "text",
              styles: {
                fontSize: 11,
              },
              content: "__addendumAgreementNumber__ ",
            },
            {
              type: "text",
              styles: {
                fontSize: 8,
              },
              content: "established on ",
            },
            {
              type: "text",
              styles: {
                fontSize: 11,
              },
              content: "__addendumSignDate__ ",
            },
            {
              type: "text",
              styles: {
                fontSize: 8,
              },
              content: ", and place ",
            },
            {
              type: "text",
              styles: {
                fontSize: 11,
              },
              content: "__addendumSignPlace__ ",
            },
          ],
        },
        {
          type: "view",
          styles: { flexDirection: "row", alignItems: "center" },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 9,
                fontFamily: "Roboto-Bold",
              },
              content: "CLIENT : ",
            },
            {
              type: "text",
              styles: {
                fontSize: 11,
                marginLeft: 80,
              },
              content: "__addendumClient__ ",
            },
          ],
        },
        {
          type: "view",
          styles: { flexDirection: "row", alignItems: "center" },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 9,
                fontFamily: "Roboto-Bold",
              },
              content: "SERVICE PROVIDER : ",
            },
            {
              type: "text",
              styles: {
                fontSize: 11,
                marginLeft: 29,
              },
              content: "__addendumServiceProvider__ ",
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
          },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 9,
                fontFamily: "Roboto-Bold",
                textTransform: "uppercase",
              },
              content: "Name of Vessel : ",
            },
            {
              type: "text",
              styles: {
                fontSize: 11,
                marginLeft: 38,
              },
              content: "__addendumVesselName__ ",
            },
          ],
        },
        {
          type: "view",
          styles: { flexDirection: "row", marginBottom: 20 },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "50%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "FROM : ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginLeft: 86,
                  },
                  content: "__addendumTermFrom__",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "50%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "TO : ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginLeft: 86,
                  },
                  content: "__addendumTermTo__",
                },
              ],
            },
          ],
        },
        {
          type: "text",
          styles: { fontSize: 8, marginBottom: 2 },
          content: "It has been agreed",
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flex: 1,
                marginHorizontal: 8,
                fontSize: 9,
                fontFamily: "Roboto-Bold",
                textAlign: "center",
              },
              content: "CHANGE/S OF PORT/S OF CALL",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
              },
              items: [{}],
            },
          ],
        },

        {
          type: "view",

          styles: {
            height: 90,
            overflow: "hidden",
            border: "1pt solid #000000",
            padding: 5,
          },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 10,
                marginTop: 5,
                marginBottom: 5,
              },
              content: "__addendumChanges__",
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flex: 1,
                marginHorizontal: 8,
                fontSize: 9,
                fontFamily: "Roboto-Bold",
                textAlign: "center",
              },
              content: "CHANGES OF PRICE",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "40%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                      },
                      content:
                        "The price of the Service is modified as follows : ",
                    },
                  ],
                },

                {
                  type: "view",
                  specialType: "choice",
                  linkedField: "addendumPriceChange",
                  withPadding: true,
                  styles: {
                    flexDirection: "row",
                    width: "60%",
                    alignItems: "center",
                    fontSize: 8,
                  },
                  items: [],
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "40%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                  },
                  content: "CURRENCY : ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                  },
                  content: "__addendumCurrency__",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "60%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                  },
                  content: "COST CHANGE : ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginLeft: 70,
                  },
                  content: "__addendumPriceChangeValue__ ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                  },
                  content: "EXC-VAT",
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            marginTop: 10,
            fontSize: 8,
            flexDirection: "row",
          },
          items: [
            {
              type: "text",
              content: "Total price of the Service ",
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto-Bold",
              },
              content: "after this addendum",
            },
          ],
        },

        {
          type: "view",
          styles: {
            marginTop: 10,
            flexDirection: "row",
            alignItems: "center",
          },
          items: [
            {
              type: "text",
              styles: { fontSize: 8, textTransform: "uppercase", width: "70%" },
              content:
                "Total price for Service Package - Voyage, Services and Accomodation : ",
            },
            {
              type: "view",
              styles: {
                width: "30%",
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: { fontSize: 11 },
                  content:
                    "__addendumTotalPriceExclVat__ __addendumCurrency__ ",
                },
                {
                  type: "text",
                  styles: { fontSize: 8 },
                  content: "EXC-VAT",
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                ...styles.textContent,
                flexDirection: "row",
                alignItems: "center",
                width: "40%",
              },
              items: [
                {
                  type: "text",
                  styles: { fontSize: 8, textTransform: "uppercase" },
                  content: "VAT rate : ",
                },
                {
                  type: "text",
                  styles: { fontSize: 11, marginLeft: 11 },
                  content: "__addendumVATRate__ %",
                },
              ],
            },
            {
              type: "view",
              styles: {
                ...styles.textContent,
                flexDirection: "row",
                alignItems: "center",
                width: "60%",
              },
              items: [
                {
                  type: "text",
                  styles: { fontSize: 8, textTransform: "uppercase" },
                  content: "VAT amount : ",
                },
                {
                  type: "text",
                  styles: { fontSize: 11, marginLeft: 96, width: "50%" },
                  content: "__addendumVatAmount__ __addendumCurrency__",
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            marginTop: 10,
            flexDirection: "row",
            alignItems: "center",
          },
          items: [
            {
              type: "text",
              styles: { fontSize: 8, textTransform: "uppercase", width: "70%" },
              content:
                "Total price for Service Package - Voyage, Services and Accomodation : ",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: { fontSize: 11 },
                  content:
                    "__addendumTotalPriceInclVat__ __addendumCurrency__ ",
                },
                {
                  type: "text",
                  styles: { fontSize: 8 },
                  content: "INC-VAT",
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                ...styles.textContent,
                flexDirection: "row",
                alignItems: "center",
                width: "40%",
              },
              items: [{}],
            },
            {
              type: "view",
              styles: {
                ...styles.textContent,
                flexDirection: "row",
                alignItems: "center",
                width: "60%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                  },
                  content: "Advance provisioning allowance : ",
                },
                {
                  type: "text",
                  styles: { fontSize: 11, marginLeft: 6, width: "40%" },
                  content:
                    "__addendumAdvanceProvisioning__ __addendumCurrency__",
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                ...styles.textContent,
                flexDirection: "row",
                alignItems: "center",
                width: "40%",
              },
              items: [{}],
            },
            {
              type: "view",
              styles: {
                ...styles.textContent,
                flexDirection: "row",
                alignItems: "center",
                width: "60%",
              },
              items: [
                {
                  type: "text",
                  styles: { fontSize: 8, textTransform: "uppercase" },
                  content: "Security deposit : ",
                },
                {
                  type: "text",
                  styles: { fontSize: 11, marginLeft: 75, width: "40%" },
                  content: "__addendumSecurityDeposit__ __addendumCurrency__",
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flex: 1,
                marginHorizontal: 8,
                fontSize: 9,
                fontFamily: "Roboto-Bold",
                textAlign: "center",
              },
              content: "TERMS OF ADDITIONAL PAYMENT",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 5,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: { fontSize: 8 },
                  content: "AMOUNT : ",
                },
                {
                  type: "text",
                  styles: { fontSize: 11 },
                  content: "__addendumTermAmount__ __addendumCurrency__",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: { fontSize: 8 },
                  content: "DATE : ",
                },
                {
                  type: "text",
                  styles: { fontSize: 11 },
                  content: "__addendumTermDate__",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "30%",
              },
              items: [
                {
                  type: "text",
                  styles: { fontSize: 8 },
                  content: "PAYMENT METHOD : ",
                },
                {
                  type: "text",
                  styles: { fontSize: 11 },
                  content: "__addendumTermPaymentMethod__",
                },
              ],
            },
          ],
        },

        {
          type: "text",
          styles: {
            fontSize: 11,
          },
          content: "__addendumTermComment__",
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flex: 1,
                marginHorizontal: 8,
                fontSize: 9,
                fontFamily: "Roboto-Bold",
                textAlign: "center",
              },
              content: "SIGNATURES",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          attrs: { wrap: false },
          styles: {},
          items: [
            {
              type: "view",
              styles: {
                border: "1pt solid #000000",
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                    borderRight: "1pt solid #000000",
                    padding: 5,
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "CLIENT : ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 11,
                        paddingTop: 5,
                      },
                      content: "__addendumClient1__",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        paddingTop: 5,
                      },
                      content: "DATE : ",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 6,
                        paddingTop: 5,
                      },
                      content:
                        'Represented by "name, capacity of signature, full address", duly authorised as the Client\'s reprensentative for the signature of this Agreement',
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                        paddingBottom: 10,
                      },
                      content: "SIGNATURE : ",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                    padding: 5,
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "SERVICE PROVIDER :  ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 11,
                        paddingTop: 5,
                      },
                      content: "__addendumServiceProvider1__ ",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        paddingTop: 5,
                        fontSize: 8,
                      },
                      content: "DATE : ",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        paddingTop: 5,
                        fontSize: 6,
                      },
                      content:
                        'Represented by "name, capacity of signature, full address", duly authorised as the Service Provider\'s reprensentative for the signature of this Agreement',
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                        paddingBottom: 10,
                      },
                      content: "SIGNATURE :  ",
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                border: "1pt solid #000000",
                marginTop: 10,
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "33%",
                    borderRight: "1pt solid #000000",
                    padding: 5,
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "BROKER : ",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        paddingTop: 10,
                      },
                      content: "DATE : ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 6,
                        paddingTop: 10,
                        paddingBottom: 30,
                      },
                      content:
                        'Represented by "name, capacity of signature, full address", duly authorised as the Service Provider\'s reprensentative for the signature of this Agreement',
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "33%",
                    borderRight: "1pt solid #000000",
                    padding: 5,
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "CENTRAL AGENT : ",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        paddingTop: 10,
                      },
                      content: "DATE : ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        paddingTop: 10,
                        fontSize: 6,
                      },
                      content:
                        'Represented by "name, capacity of signature, full address", duly authorised as the Service Provider\'s reprensentative for the signature of this Agreement',
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "33%",
                    padding: 5,
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "STAKEHOLDER : ",
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        paddingTop: 10,
                      },
                      content: "DATE : ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        paddingTop: 10,
                        fontSize: 6,
                      },
                      content:
                        'Represented by "name, capacity of signature, full address", duly authorised as the Service Provider\'s reprensentative for the signature of this Agreement',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default jsonView;
